
import Form from "./Form.vue";
import FinanceiroData from "./FinanceiroData";
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  name: "app-financeiro-create",
  data() {
    return {
      financeiro: new FinanceiroData({
        data: moment().format("YYYY-MM-DD"),
      }),
    };
  },
  components: {
    Form,
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    this.financeiro.data = moment().format("YYYY-MM-DD");
  },
};
